import React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { useNavigate } from 'react-router-dom'
import MobileHeader from '../../../components/MobileHeader/MobileHeader'
import { useSetHeaderTitle } from '../../../hooks/hooks'
import { DashboardContent } from '../DashboardLayout/DashboardLayout.styles'
import { useFetchBuckBreakersQuery } from '../../../services/api'
import { useProcessError } from '../../../hooks/hooks'
import { routes } from '../../../utils/constants'
import { animateComponent } from '../../../utils/hoc'
import BuckBreakerDrawer from './BuckbBreakerDrawer'
import { BuckBreakerList, BuckBreakerLoadingState, BuckBreakerEmptyState } from './BuckBreackerComponents'
import Button from '../../../components/Button/Button'
import TextWithIcon from '../../../components/TextWithIcon'
import AddIcon from '@mui/icons-material/Add'
import { colors } from '../../../styles/_var'

const useBuckBreakerHome = () => {
  const navigate = useNavigate()
  const processError = useProcessError()
  const { data, error, isLoading } = useFetchBuckBreakersQuery({})
  const [openBuckBreakerDrawer, setOpenBuckBreakerDrawer] = React.useState(false)
  const toggleBuckBreakerDrawer = () => setOpenBuckBreakerDrawer(!openBuckBreakerDrawer)
  const handleBuckBreakerClick = (friendlyId: string) => {
    navigate(routes.BUCK_BREAKER.replace(':buckbreaker_id', friendlyId))
  }
  const hasBuckBreakers = !!data?.payload?.length

  return {
    data,
    error,
    isLoading,
    hasBuckBreakers,
    openBuckBreakerDrawer,
    toggleBuckBreakerDrawer,
    handleBuckBreakerClick,
    processError,
  }
}

const BuckBreakerHome = () => {
  useSetHeaderTitle('Buck Breakers')
  const { 
    data, 
    error, 
    isLoading, 
    hasBuckBreakers, 
    openBuckBreakerDrawer, 
    toggleBuckBreakerDrawer, 
    handleBuckBreakerClick, 
    processError 
  } = useBuckBreakerHome()

  React.useEffect(() => {
    processError(error)
  }, [error, processError])


  return (
    <DashboardContent isMobile>
      <MobileHeader />
      <Container>
        <Box mt={3} mb={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={toggleBuckBreakerDrawer}
            center
          >
            <TextWithIcon
              color={colors.white}
              icon={<AddIcon />}
              weight="semibold"
            >
              Start Buck Breaker
            </TextWithIcon>
          </Button>
        </Box>
        <Box>
          {isLoading ? (
            <BuckBreakerLoadingState />
          ) : hasBuckBreakers ? (
            <BuckBreakerList 
              buckbreakers={data?.payload || []} 
              onBuckBreakerClick={handleBuckBreakerClick} 
            />
          ) : (
            <BuckBreakerEmptyState />
          )}
        </Box>
      </Container>
      <BuckBreakerDrawer isOpen={openBuckBreakerDrawer} closeDrawer={toggleBuckBreakerDrawer} />
    </DashboardContent>
  )
}

export default animateComponent(BuckBreakerHome, true)
